// extracted by mini-css-extract-plugin
export default {"social-links":"Social_social-links__vocuz","social-links__item":"Social_social-links__item__TRhX2"};